import { AppBar, Backdrop, Card, CardContent, CircularProgress, Container, makeStyles, Toolbar, Typography } from '@material-ui/core';
import clsx from 'clsx';
import isEmpty from 'lodash.isempty';
import React, { useCallback, useEffect } from 'react';
import ReactJson from 'react-json-view';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { cancelBooking, confirmBooking, createNewBooking, fetchWhitelabelDeadline, getVerifiedSchedules, updateWhitelabelBookingDate } from 'services/booking.service';
import { getDefaultPaymentMethod } from 'services/payments.service';
import { parseBookingStatus } from 'util/bookingStates';
import { filterNonNull } from 'util/format';
import { useState } from 'util/stateref';
import { useTrackEvent } from 'util/trackEvent';
import { isWaitingForPollState, rebookedState, STEP_STATE_SCHEDULE } from '../RecoilState';
import { stepState } from '../RecoilState';
import { Timeslots } from './Timeslots';
import { analyticsIdentifierState } from '..';
import moment from "moment-timezone";
import { TimeslotsV2 } from './TimeslotsV2';

const useStyles = makeStyles((theme) => {
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    root: {
      flexGrow: 1,

    },
    padded: {
      '& > *': {
        margin: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
          margin: theme.spacing(1)
        }

      },
    },
    top: {
      bottom: 'auto',
      top: 0,
      right: 'auto',
    },
    appBar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-evenly',
    },
    title: {
      flexGrow: 1
    }
  }
})
const Reschedule = ({ rebook, asView = true }) => {
  const classes = useStyles()
  const history = useHistory()

  const { serviceId } = useParams()

  const [booking, setBooking] = useState(null);

  const [loading, setLoading] = useState(true);
  const [isInvalid, setIsInvalid] = useState();
  const { user, getUser, fetchBookingByAuth } = useUserState()
  const [userState, setUserState, userStateRef] = useState();

  const [errorBlock, setErrorBlock] = useState(false);

  const [schedules, setSchedules] = useState([]);

  const setStepState = useSetRecoilState(stepState)

  const trackEvent = useTrackEvent()

  const [daysFinalOffset, setDaysFinalOffset] = useState(0);

  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);

  useEffect(() => {
    setStepState(STEP_STATE_SCHEDULE)
  }, []);

  useEffect(() => {
    async function fetchUser() {
      setLoading(true)
      const user = await getUser(serviceId)
      setUserState(user)

      setLoading(false)
    }
    fetchUser()
  }, []);

  const [analyticsIdentifier, setAnalyticsIdentifier] = useRecoilState(analyticsIdentifierState);
  const fetchAuthOrBooking = useCallback(
    async () => {
      setLoading(true)
      setErrorBlock(false)
      const result = await fetchBookingByAuth(serviceId, analyticsIdentifier)
      setAnalyticsIdentifier(result?.client?.id)
      if (result?.request_code || result?.requires_validation) {
        history.replace(`/bookings/login/${serviceId}` + history.location.search)
        return
      }
      if ((userStateRef?.current?.user?.id || userStateRef?.current?.client?.id) !== result?.client?.id) {
        setIsInvalid(true)
        history.replace(`/bookings/oops/${serviceId}` + history.location.search)
        return;
      }

      if (result?.white_label_partner?.id) {
        const deadline = await fetchWhitelabelDeadline(result?.white_label_partner?.id)
        setDaysFinalOffset(moment.utc().add(deadline?.days, 'days').toDate())
      } else {
        setDaysFinalOffset(moment.utc(result?.date_scheduled_orig).toDate())
      }

      setBooking(result)

      setLoading(false)

      setIsInvalid(false)
    },
    [history, serviceId, userStateRef],
  );

  useEffect(() => {
    fetchAuthOrBooking()
  }, [serviceId]);

  return (
    <>
      <Backdrop open={loading || isWaitingForPoll} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar elevation={0} position="static" color="default" className={clsx(classes.top, classes.appBar)}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            {rebook ? 'Rebook' : 'Reschedule'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container disableGutters className={clsx(classes.root, classes.padded)}>
        <TimeslotsV2
          view="Reschedule"
          rebook={rebook}
          serviceId={serviceId}
          oldTime={booking?.date_scheduled}
          booking={booking}
          autoConfirm
          maxDate={daysFinalOffset}
          minDate={moment().add(1, 'days').startOf('day').toDate()}
        />

      </Container>
    </>
  )
}

export { Reschedule };
